import { useEffect, useState } from "react";
import {
  analyticsAvailable,
  consentDecision,
  grantConsent,
  revokeConsent,
  identifyAccount,
} from "../lib/observability";

// Accept and reject are given equal weight, nothing is pre-selected,
// and rejecting fully blocks PostHog. The footer "Cookie settings"
// link dispatches `pg-open-consent` to reopen this for a change.
export function ConsentBanner({
  accountId,
}: {
  accountId?: string | undefined;
}) {
  const [open, setOpen] = useState(
    () => analyticsAvailable() && consentDecision() === null,
  );

  useEffect(() => {
    const reopen = () => {
      if (analyticsAvailable()) setOpen(true);
    };
    window.addEventListener("pg-open-consent", reopen);
    return () => window.removeEventListener("pg-open-consent", reopen);
  }, []);

  if (!open) return null;

  return (
    <div className="consent" role="dialog" aria-label="Cookie consent">
      <div className="consent-inner">
        <p>
          We use privacy-preserving product analytics (PostHog, EU) to
          understand how the dashboard is used. It is off until you accept
          and never records what you look up. See our{" "}
          <a href="https://plaingraph.com/cookies">cookie policy</a>.
        </p>
        <div className="consent-actions">
          <button
            type="button"
            className="btn secondary"
            onClick={() => {
              revokeConsent();
              setOpen(false);
            }}
          >
            Reject
          </button>
          <button
            type="button"
            className="btn"
            onClick={() => {
              grantConsent();
              if (accountId) identifyAccount(accountId);
              setOpen(false);
            }}
          >
            Accept
          </button>
        </div>
      </div>
    </div>
  );
}
